/**
 * A dictionary containing error messages to show in Datebox and Datebox.Field
 */
export const errorMessages: Record<string, string> = {
  "unit out of range": "Date does not exist",
  unparsable: "Incorrect format",
};
